import { DesignResource } from '@/api/serverApi'
import DesignGridCard from '@/components/grid-items/DesignGridCard'
import { Link } from 'react-router-dom'

type PropTypes = {
  designs?: DesignResource[]
  footerElements?: React.ReactNode[]
  dropdown?: (design: DesignResource) => React.ReactNode

}

function UngroupedDesignGridView ({ designs, footerElements, dropdown }: PropTypes) {
  return (
    <ul className="w-full flex flex-row items-center justify-start flex-wrap">
      {
        designs?.map((design) => (
          <Link to={`/designs/${design.id}`} key={design.id}>
            <DesignGridCard design={design} dropdown={dropdown?.(design)} />
          </Link>
        ))
      }
      {
        ...(footerElements ?? [])
      }
    </ul>
  )
}

export default UngroupedDesignGridView
